<template>
  <div role="alert" :class="`banner ${type}`">
    <div v-if="title" class="banner-title-wrap">
      <h3 class="banner-title">
        <v-icon v-if="icon" :name="icon" scale="0.8" class="mr-1" /> {{ title }}
      </h3>
    </div>
    <div v-if="message" class="banner-message-wrap">
      <p class="banner-message">
        {{ message }}
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: "Banner",
  props: {
    icon: {
      default: "",
      type: String,
    },
    message: {
      default: "",
      type: String,
    },
    title: {
      default: "",
      type: String,
    },
    type: {
      default: "alert",
      type: String,
    },
  },
};
</script>

<style scoped>
.banner {
  @apply shadow-md rounded-lg overflow-hidden max-w-lg mx-auto;
}

.banner-title-wrap {
  @apply bg-info px-4 py-2;

  @screen sm {
    @apply py-3;
  }
}

.banner-message-wrap {
  @apply bg-brand-light px-4 py-2;

  @screen sm {
    @apply py-3;
  }
}

.banner-title {
  @apply text-white mb-0 text-base;

  @screen md {
    @apply text-lg;
  }

  @screen lg {
    @apply text-xl;
  }
}

.banner-message {
  @apply mb-0 text-brand-dark text-sm;

  @screen md {
    @apply text-base;
  }
}

.error {
  .banner-title-wrap {
    @apply bg-danger;
  }

  .banner-message-wrap {
    @apply bg-white;
  }
}
</style>
